import { createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { baseURL } from "../../BaseUrl"

const getToken = () => localStorage.getItem("workManagement");

// API headers including token
const getAuthHeaders = () => ({
  headers: {
    Authorization: `Bearer ${getToken()}`,
  },
});
export const getAllPunchIndata = createAsyncThunk(
    "punchin/getAllPunchIndata",
    async () => {
        try{
            const response = await baseURL.get(`/punch-in-out`,getAuthHeaders())
            // console.log("response.data==>",response.data)
            return response.data.data;
        }catch(error){
            throw error
        }
    }
)
export const punchinSlice = createSlice({
    name:"punch",
    initialState:{
        punchData:[],
        loading:false,
        error:null
    },
    reducers:{},
    extraReducers:(builder)=>{
        builder
        .addCase(getAllPunchIndata.pending,(state)=>{
            state.loading=false
        })
        .addCase(getAllPunchIndata.fulfilled,(state,action)=>{
            state.loading=false
            state.punchData=action.payload
        })
        .addCase(getAllPunchIndata.rejected,(state,action)=>{
            state.loading=false
            state.error=action.error
        })
    }
})
export const getPunchData =(state)=>state.punch.punchData
export const punchError = (state) => state.punch.loading
export default punchinSlice.reducer;